var map = {
	"./$.png": "OszD",
	"./4.png": "M7IB",
	"./AED.png": "whAX",
	"./AUD.png": "6fGN",
	"./CAD.png": "K/Ig",
	"./CHF.png": "gyY6",
	"./CNH.png": "LR2z",
	"./DKK.png": "G540",
	"./EUR.png": "4dqx",
	"./GBP.png": "OPIf",
	"./HKD.png": "GoXy",
	"./IDR.png": "UpqQ",
	"./JPY.png": "1KRC",
	"./KRW.png": "Zknc",
	"./KWD.png": "XpbM",
	"./MOP.png": "2PmQ",
	"./MYR.png": "Erzu",
	"./NZD.png": "EDfN",
	"./Our.png": "CEvq",
	"./PHP.png": "kMiB",
	"./SEK.png": "ZLUd",
	"./SGD.png": "N7iq",
	"./THB.png": "4FwQ",
	"./TPE_LOGO.png": "Yp1C",
	"./TWD.png": "WqHl",
	"./USD.png": "Teaw",
	"./VND.png": "nv1O",
	"./ZAR.png": "mFtM",
	"./account_content_icon1.png": "XN7a",
	"./account_content_icon2.png": "E7Ye",
	"./account_content_icon3.png": "Mzfj",
	"./account_content_icon4.png": "kGqF",
	"./account_content_line.png": "wosl",
	"./bank.png": "yk+l",
	"./banner-carousel-20251211-154026.png": "THXZ",
	"./banner-carousel-20251211-154031.png": "2rcW",
	"./banner-fan.png": "dBdQ",
	"./banner-jian.png": "n/o8",
	"./banner3.png": "5dQR",
	"./banner_bg.png": "PsOM",
	"./banner_fan.png": "cvUY",
	"./banner_jian.png": "bnkh",
	"./banner_table_bg.png": "zjwh",
	"./banner_table_icon1.png": "5U6L",
	"./banner_table_icon1_select.png": "OUEt",
	"./banner_table_icon2.png": "FMbW",
	"./banner_table_icon2_select.png": "0SJn",
	"./banner_table_switch.png": "Q35f",
	"./bg0.png": "zrmD",
	"./bg1.png": "ct0E",
	"./bg2.png": "idSQ",
	"./bg3.png": "WfMM",
	"./bgyuan.png": "+9tJ",
	"./bottom_bg.png": "1RAy",
	"./bottom_contact1_icon.png": "vRkM",
	"./bottom_contact2_icon.png": "GrAY",
	"./bottom_contact3_icon.png": "yWP4",
	"./bottom_contact4_icon.png": "lW2t",
	"./bottom_logo.png": "Lm6s",
	"./bus.png": "UyGu",
	"./cny.png": "CX0G",
	"./contact_ad_icon.png": "n6c4",
	"./contact_bus_icon.png": "kyYK",
	"./contact_map_icon.png": "d1nj",
	"./contact_subway_icon.png": "ZENN",
	"./contact_table_bg.png": "l2rW",
	"./contact_table_img.png": "bk5f",
	"./contact_table_message_rec.png": "bqHA",
	"./cz.png": "JQ88",
	"./dh.png": "wKuF",
	"./door.png": "ozWi",
	"./dz.png": "poL2",
	"./erweima.png": "iyHX",
	"./exchange.png": "1eim",
	"./float_advisory.png": "G5Ua",
	"./float_back.png": "NMAa",
	"./float_icon2.png": "Pw9F",
	"./float_icon22-1.png": "da/G",
	"./float_icon22.png": "rZYz",
	"./float_mail.png": "2Iag",
	"./float_phone.png": "O98k",
	"./hb.png": "RMFE",
	"./hk.png": "qQKU",
	"./huan.png": "6sri",
	"./kj.png": "L5nR",
	"./logo.png": "nWR2",
	"./map.png": "hwiJ",
	"./metro.png": "DdQw",
	"./money.png": "tqGv",
	"./money2.png": "oKnI",
	"./nan.png": "Wmoz",
	"./new_account_content_icon1.png": "NTUE",
	"./new_account_content_icon2.png": "ps2r",
	"./new_account_content_icon3.png": "j7mQ",
	"./new_account_content_icon4.png": "F5HY",
	"./new_account_content_line.png": "beZa",
	"./new_bussiness_btn_icon.png": "vr4s",
	"./new_bussiness_img1.png": "RBpJ",
	"./new_bussiness_img2.png": "3Sur",
	"./new_bussiness_img3.png": "pl42",
	"./new_float_code.png": "0se7",
	"./new_float_code_1.png": "eU07",
	"./new_float_icon1-1.png": "PvvZ",
	"./new_float_icon1.png": "Pkec",
	"./new_float_icon2-2.png": "FhrU",
	"./new_float_icon2.png": "2RSd",
	"./new_float_icon3-3.png": "6KUZ",
	"./new_float_icon3.png": "iauq",
	"./new_float_icon4-4.png": "KblI",
	"./new_float_icon4.png": "YHBe",
	"./new_float_icon5-5.png": "fDch",
	"./new_float_icon5.png": "pxOd",
	"./news1_img.png": "EAdl",
	"./news2_img.png": "vI5W",
	"./news3_img.png": "HY6i",
	"./news4_img.png": "RkUd",
	"./news5_img.png": "u6jr",
	"./news6_img.png": "Ho23",
	"./news7_img.png": "6v35",
	"./phone.png": "HjcO",
	"./png5.png": "xJB1",
	"./process.png": "0JjP",
	"./process_bank_img.png": "EzjE",
	"./process_content_icon1.png": "CmY0",
	"./process_content_icon2.png": "zqf8",
	"./process_content_icon3.png": "Crr4",
	"./process_content_icon4.png": "VfAc",
	"./process_content_icon5.png": "31Oh",
	"./process_content_line.png": "NHKn",
	"./process_content_seq.png": "Xa+h",
	"./process_content_seq1.png": "Jjug",
	"./process_content_seq2.png": "Wcvc",
	"./process_content_seq3.png": "CxY+",
	"./process_content_seq4.png": "YDee",
	"./process_content_seq5.png": "g0US",
	"./process_coop_line.png": "4QEx",
	"./process_coop_seq1.png": "NORV",
	"./process_coop_seq2.png": "hLzE",
	"./process_coop_seq3.png": "0LsU",
	"./process_coop_seq4.png": "BTlR",
	"./process_coop_seq5.png": "opKy",
	"./process_rec.png": "CbAL",
	"./profile.png": "sx4D",
	"./qq.png": "Hr33",
	"./reason_content1_seq.png": "xae8",
	"./reason_content2_seq.png": "ljr6",
	"./reason_content3_seq.png": "Nht9",
	"./reason_content4_seq.png": "jueo",
	"./reason_content5_seq.png": "Lnbh",
	"./reason_content6_seq.png": "UW6z",
	"./service_content1-1_icon.png": "rbos",
	"./service_content1_icon.png": "8ICJ",
	"./service_content1_img.png": "ecko",
	"./service_content2_icon.png": "2eSE",
	"./service_content2_img.png": "NcqH",
	"./service_content3-3_icon.png": "TNlB",
	"./service_content3_icon.png": "wfAW",
	"./service_content3_img.png": "yNEe",
	"./service_content4-4_icon.png": "+1i6",
	"./service_content4_icon.png": "T8/Q",
	"./service_content4_img.png": "Jf/E",
	"./service_content5-5_icon.png": "+HGA",
	"./service_content5_icon.png": "EqhU",
	"./service_content5_img.png": "vSoX",
	"./service_content6_icon.png": "zu41",
	"./service_content6_img.png": "+thg",
	"./service_content_line.png": "Aowa",
	"./usa.png": "Q+lg",
	"./yd.png": "F8pV",
	"./yuan.png": "v5Qg",
	"./yuan2.png": "K/Bm",
	"./yuan3.png": "t3le",
	"./yuan4.png": "0P+K",
	"./zf.png": "7uca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Hj7";